var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    this.resizeEdges.includes("t")
      ? _c("div", { staticClass: "vue-modal-top" })
      : _vm._e(),
    _vm._v(" "),
    this.resizeEdges.includes("b")
      ? _c("div", { staticClass: "vue-modal-bottom" })
      : _vm._e(),
    _vm._v(" "),
    this.resizeEdges.includes("l")
      ? _c("div", { staticClass: "vue-modal-left" })
      : _vm._e(),
    _vm._v(" "),
    this.resizeEdges.includes("r")
      ? _c("div", { staticClass: "vue-modal-right" })
      : _vm._e(),
    _vm._v(" "),
    this.resizeEdges.includes("tr")
      ? _c("div", { staticClass: "vue-modal-topRight" })
      : _vm._e(),
    _vm._v(" "),
    this.resizeEdges.includes("tl")
      ? _c("div", { staticClass: "vue-modal-topLeft" })
      : _vm._e(),
    _vm._v(" "),
    this.resizeEdges.includes("br")
      ? _c("div", { class: _vm.className, attrs: { id: _vm.getID } })
      : _vm._e(),
    _vm._v(" "),
    this.resizeEdges.includes("bl")
      ? _c("div", { staticClass: "vue-modal-bottomLeft" })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }